module.exports = __webpack_public_path__ + "static/media/cq_logout b.01eb4c3d.svg";